import React from "react";
import {withNamespaces} from "react-i18next";

const ConnectionStatusConstants = {
    ONLINE: "online",
    OFFLINE: "offline",
    HILIGHT_PROBLEM: "hilight-problem"
}

const ConnectionStatus = ({status, networkStatus, t}) => {
    // eslint-disable-next-line no-unused-vars
    let connectionStatus = ''
    let icon = "";

    if(status === false && networkStatus === false) {
        connectionStatus = ConnectionStatusConstants.OFFLINE;
        icon = "fas fa-circle";
    }
    else if(status === true && networkStatus === true) {
        connectionStatus = ConnectionStatusConstants.ONLINE;
        icon = "fas fa-circle";
    }
    else {
        connectionStatus = ConnectionStatusConstants.HILIGHT_PROBLEM;
        icon = "fas fa-exclamation-triangle";
    }

    return (
        <div>
            <i className={`dvc-status ${icon} status-${connectionStatus}`}> </i>
        </div>
    );
};
export default withNamespaces()(ConnectionStatus);
